import Vue from "vue";
import Vuex from "vuex";
import shoppingCart from "./shop/modules/shopping-cart";
import giftShoppingCart from "./shop/modules/gift-shopping-cart";
import newGiftShoppingCart from "../modules/new-giftcard/scripts/new-gift-shopping-cart";
import styles from "./shop/modules/styles";
import user from "./shop/modules/user";
import store from "./shop/modules/storeState";
import PriceTriggerState from "./shop/modules/PriceTriggerState";
import createPersistedState from "vuex-persistedstate";
import menuState from "./shop/modules/menuState";
import surchargeState from "./shop/modules/surchargeState";
import shareCart from "./shop/modules/shareCart";
import guestCount from "./shop/modules/guestCount";
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    shoppingCart,
    giftShoppingCart,
    newGiftShoppingCart,
    user,
    store,
    PriceTriggerState,
    styles,
    menuState,
    surchargeState,
    shareCart,
    guestCount,
  },
  plugins: [
    createPersistedState({
      paths: [
        "shoppingCart",
        "giftShoppingCart",
        "newGiftShoppingCart",
        "store",
        "initLoggerData",
        "styles",
        "PriceTriggerState",
        "user",
        "surchargeState",
        "shareCart",
        "guestCount",
      ],
    }),
  ],
  strict: debug,
});
